import decode from 'jwt-decode';

const TOKEN = 'aaco_token_assetinv';

class TokenUtil {
  getToken() {
    return localStorage.getItem(TOKEN);
  }

  setToken(token: any) {
    return localStorage.setItem(TOKEN, token);
  }

  clearToken() {
    return localStorage.setItem(TOKEN, null);
  }

  isTokenValid() {
    const token = this.getToken();
    this.getData();
    if (!token) {
      return false;
    }

    try {
      const { exp } = decode(token);
      if (exp < new Date().getTime() / 1000) {
        return false;
      }
    } catch (e) {
      return false;
    }

    return true;
  }

  getData() {
    const token = this.getToken();
    const parsedToken = decode(token!);
    return parsedToken;
  }
}

// follows singletons object of class
export default new TokenUtil();
